import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { AgendaEventsView } from 'owa-agenda-events-list';
import CalendarEventPeekCallout from './CalendarEventPeekCallout';
import { CalendarViewBaseProps, CalendarViewType } from '../schema';
import ExpandableDatePicker from './ExpandableDatePicker';
import useAgendaViewViewState from '../hooks/useAgendaViewViewState';

export interface AgendaViewProps extends CalendarViewBaseProps {
    scenarioId: string;
    selectedDate: Date;
    onDateUpdated: (date: Date) => void;
}

export default observer(function AgendaView(props: AgendaViewProps) {
    const {
        ref,
        onAgendaListCallback,
        calendarEventInteractionCallbacks,
        onSelectDate,
    } = useAgendaViewViewState(props);

    return (
        <div className={styles.agendaContainer} ref={ref}>
            <ExpandableDatePicker
                selectedDate={props.selectedDate}
                onSelectDate={onSelectDate}
                numDaysInDayView={1}
                viewType={CalendarViewType.Agenda}
                showNavigation={true}
                // in agenda view navigated date and selected date are the same so onSelectToday is same function as onSelectDate
                onSelectToday={onSelectDate}
            />
            <AgendaEventsView
                scenarioId={props.scenarioId}
                callbacks={{
                    calendarEventInteractionCallback: calendarEventInteractionCallbacks,
                    listInteractionCallback: onAgendaListCallback,
                }}
                styles={{ listContainer: styles.agenda }}
            />
            <CalendarEventPeekCallout
                target={props.peekTarget}
                onDismissed={props.onEventsPeekCalloutDismissed}
            />
        </div>
    );
});
